import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { USER_TYPE } from "../../constants/common";
import { setUser } from "../../redux/slices/userSlice";
import authServices from "../../services/authServices";
import schoolServices from "../../services/schoolServices";
import studentServices from "../../services/studentServices";
import teacherServices from "../../services/teacherServices";
import { getUserRoleById } from "../../utils/getUserRoleById";

const B12Callback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [accessToken, setAccessToken] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const handleCallback = () => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const access_token = params.get("access_token");
    const id_token = params.get("id_token");

    if (access_token) {
      setAccessToken(access_token);
      setIdToken(id_token);
    } else {
      setErrorMessage("Tokens not found in the callback URL.");
      setLoading(false);
    }
  };

  const loginWithAccessToken = async (access_token, id_token) => {
    try {
      const formData = new FormData();
      formData.append("accessToken", access_token);
      formData.append("idTokenB12", id_token);

      const response = await authServices.loginAsB12(formData);

      const role = getUserRoleById(response.user_type.id);
      if (!role) throw new Error("Invalid user type id received from the response");

      let user = { ...response, role };

      if (role === USER_TYPE.SCHOOL.ROLE) {
        const schoolAdminResponse = await schoolServices.getSchoolData();
        user = { ...user, ...schoolAdminResponse?.schools?.[0], role };
      } else if (role === USER_TYPE.TEACHER.ROLE) {
        const teacherResponse = await teacherServices.getTeacherData();
        user = {
          ...user,
          teacher_id: teacherResponse?.id,
          has_children_courses: teacherResponse?.has_children_courses,
          has_other_courses: teacherResponse?.has_other_courses,
          school_name: teacherResponse?.school_name,
        };
      } else if (role === USER_TYPE.STUDENT.ROLE) {
        const studentResponse = await studentServices.getStudentByUserID(response?.id);
        user = {
          ...user,
          student_id: studentResponse?.id,
          school: studentResponse?.school,
        };
      }

      dispatch(setUser(user));
      setErrorMessage("");
      navigate("/dashboard"); // Redirect to dashboard after success
    } catch (error) {
      setErrorMessage(error.message || "An error occurred during login.");
      setTimeout(() => setErrorMessage(""), 5000);
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleCallback();
  }, []);

  useEffect(() => {
    if (accessToken) {
      loginWithAccessToken(accessToken, idToken);
    }
  }, [accessToken, idToken]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white text-center">
      <h1 className="mb-4 text-2xl font-bold">B12 Callback</h1>
      {loading && <p className="mb-2 text-blue-500">Processing login...</p>}
      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
    </div>
  );
};

export default B12Callback;
